<p>Using the Climber App, you may change the membership's assigned payment method to a different saved payment method, or add a new one.</p>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
